module.exports = __webpack_public_path__ + "img/logo-cbgr-inverse.a48c47d9.png";